import React from 'react';
import { connect } from 'react-redux';
import {
  shouldShowActionBar,
  hasError,
  isLoading,
  shouldDisableBulkActions,
} from '../../selectors';
import { bulkActionsArchive } from '../../actions/shared/index/bulk';
import IndexActionBar from '../shared/index/action_bar';
import { clearFilter } from '../../actions/shared/index/filter';
import BulkActionButton from '../shared/index/action_bar/bulk_action/BulkActionButton';

const ContentActionBar = props => {
  let button;

  if (props.currentUser.isAdmin) {
    button = <BulkActionButton actions={props.actions} />;
  } else {
    button = [
      {
        label: 'Archive',
        iconName: 'archive',
        onClickKey: 'archive',
        modalTitle: 'Archive Content',
        modalMessage:
          'Are you sure you want to archive %selectedCount% %nItems%?',
        modalConfirmButton: 'Yes, archive',
      },
    ];
  }

  return <IndexActionBar {...props} buttons={button} />;
};

const mapStateToProps = (state, ownProps) => ({
  bulkActionDone: state.bulk.done,
  // Action Bar
  visible: shouldShowActionBar(state),
  hasError: hasError(state),
  success: state.bulk.success,
  // Counts
  selectedCount: state.bulk.selected.length,
  totalResults: state.data.totalResults,
  filterIsActive: state.filter.isActive,
  // Loading
  loading: isLoading(state),
  bulkDone: !state.bulk.inProgress && state.bulk.done,
  bulkInProgress: state.bulk.inProgress,
  bulkCount: state.bulk.count,
  bulkName: state.bulk.name,
  // BulkActionsButtons
  disabled: shouldDisableBulkActions(state),
  // Updated share records for massActions
  updatedShared: state.massActions.updatedShared,
  currentUser: state.data.meta.currentUser,
});

const mapDispatchToProps = dispatch => ({
  clearFilter: () => dispatch(clearFilter()),
  actions: {
    archive: () => dispatch(bulkActionsArchive()),
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ContentActionBar);
